module.exports = {"title":"404","layout":"page","path":"/404.html","body":"<h3>Not Found</h3>\n<p>You just hit a route that doesn’t exist</p>\n"}


// WEBPACK FOOTER //
// ../~/gatsby/dist/loaders/markdown-loader?{"config":{"siteTitle":"Coriolan UI","siteDescr":"sass mixins pack","siteAuthor":"","siteNpmUrl":"https:/www.npmjs.com/package/coriolan-ui","siteGithubUrl":"https:/github.com/coriolan-ui/coriolan-ui.github.io","linkPrefix":""},"shouldPrefix":true}!./404.md